<style lang="scss" scope>
.sp-filter-form {
  background-color: #f6f7f9;
  padding: 16px 0 0;
  display: flex;
  box-sizing: content-box;
  &.shouqi {
    // max-height: 104px;
    max-height: 94px;
    overflow: hidden;
  }
  &.small {
    .sp-filter-form-item {
      margin-bottom: 8px;
    }
    &.shouqi {
      // max-height: 80px;
    }
  }
}
.filter-form {
  &__bd {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    padding-left: 10px;
  }
  &__ft {
    width: 220px;
    padding-right: 16px;
    .btns-wrap {
      text-align: right;
    }
    .extend-wrap {
      // margin-top: 24px;
      margin-top: 12px;
      padding-left: 15px;
    }
  }
}
</style>
<template>
  <div class="sp-filter-form" :class="formClass">
    <div ref="fiterFormBd" class="filter-form__bd">
      <slot />
    </div>
    <div class="filter-form__ft">
      <div class="btns-wrap">
        <el-button type="primary" icon="ecx-icon icon-sousuo" @click="onSearch">{{ localLang==='zh'? '查询' :'query' }}<!--{{ $t('sp-filter-form.index.684581-0') }}--> </el-button>
        <el-button type="primary" plain icon="ecx-icon icon-zhongzhi" @click="onReset">
          <!-- {{ $t('sp-filter-form.index.684581-1') }} -->
            {{ localLang==='zh'? '重置':'reset' }}
        </el-button>
      </div>
      <div v-if="showExtend" class="extend-wrap">
        <el-button type="text" @click="toggleExtend">
          <i class="ecx-icon" :class="extend ? 'icon-quanbushouqi' : 'icon-quanbuzhankai'" />
            <!-- // `${extend ? $t('sp-filter-form.index.684581-2') : $t('sp-filter-form.index.684581-3')}` -->
            {{`${extend ? (localLang==='zh'?'收起':'Put it away') : (localLang==='zh'?'展开':'launch')}`}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import emitter from '@/utils/emitter'
export default {
  name: 'SpFilterForm',
  mixins: [emitter],
  props: {
    model: Object,
    size: {
      type: String,
      default: 'normal'
    },
    lang:{
      type: String,
      default: 'zh'
    }
  },
  provide() {
    return {
      filterForm: this
    }
  },
  data() {
    return {
      localLang:'zh',
      fields: [],
      showExtend: false,
      rows: 0,
      extend: false
    }
  },
  computed: {
    formClass() {
      const size = this.size
      return {
        'shouqi': !this.extend,
        'normal': size == 'normal',
        'small': size == 'small'
      }
    },
  },
  created() {
    this.$on('sp.filterForm.addField', (field) => {
      if (field) {
        this.fields.push(field)
      }
    })
    const _this = this
    window.onresize = () => {
      console.log('onresize')
      setTimeout(() => {
        _this.calcRows()
      }, 50)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcRows()
    })
    if(this.$i18n?.locale){
      this.localLang = this.$i18n.locale
    }else if(this.lang){
      this.localLang = this.lang
    }
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    toggleExtend() {
      this.extend = !this.extend
    },
    calcRows() {
      if (!this.fields.length) return;
      
      let rows = 1;
      
      // 获取第一个表单项的 offsetTop~
      const firstItemOffset = this.fields[0].$el.offsetTop;

      for (let i = 1; i < this.fields.length; i++) {
        // 如果当前表单项的 offsetTop 与第一个表单项不同，说明它已经换行
        if (this.fields[i].$el.offsetTop !== firstItemOffset) {
          rows++;
        }
      }

      // 根据行数判断是否显示展开按钮
      this.showExtend = rows > 2 && !this.extend;
      this.rows = rows;
    },
    onSearch() {
      this.$emit('onSearch')
    },
    onReset() {
      if (!this.model) {
        console.warn('[Sp Warn][sp-filter-form]model is required for resetFields to work.')
        return
      }
      this.fields.forEach((field) => {
        field.resetField()
      })
      this.$emit('onReset')
    }
  }
}
</script>
